'use strict';

// sessionStorage key shared between product/base.js and login/login.js to carry the
// originating PDP URL through the subscription login/create-account modal (SC-17165).
var SUBSCRIPTION_RESUME_URL_KEY = 'subscriptionResumePdpUrl';

/**
 * ------------------------------------------------------------------------
 * ACCESSIBILITY ENFORCER (THE FIX) - OPTIMIZED
 * ------------------------------------------------------------------------
 * Runs continuously for 5 seconds to catch late 3rd party injections 
 * (Bazaarvoice stars, chevrons), then self-destructs to save performance.
 */
(function startAccessibilityEnforcer() {
    var runCount = 0;
    var maxRuns = 10; // 10 runs * 500ms = 5 seconds total lifespan

    var interval = setInterval(function() {
        runCount++;

        try {
            // Find all slides that are currently hidden
            var $hiddenSlides = $('.slick-slide[aria-hidden="true"]');
            
            // Optimization: If no hidden slides exist, stop early
            if ($hiddenSlides.length === 0) {
                clearInterval(interval);
                return;
            }

            // TARGET SPECIFIC PROBLEM ELEMENTS
            // Added: .bv_reviewSummaryChevron (The button from your bazarvoice)
            // Added: .bv_main_container (The stars)
            // Added: .tile-image-link (The image links)
            var badSelectors = '.bv_main_container, .bv_reviewSummaryChevron, .tile-image-link';

            $hiddenSlides.find(badSelectors).attr('tabindex', '-1');
            
            // Catch generic focusable elements
            $hiddenSlides.find('a, button, input, [tabindex="0"]')
                .not('[tabindex="-1"]')
                .attr('tabindex', '-1');

        } catch (e) {
            // Fail silently
        }

        // Self-destruct after 5 seconds
        if (runCount >= maxRuns) {
            clearInterval(interval);
        }
    }, 500); 
})();

/**
 * ------------------------------------------------------------------------
 * STANDARD ACCESSIBILITY UPDATE
 * ------------------------------------------------------------------------
 * Safe to call multiple times. Fixes the "Focusable Hidden Element" issue.
 * @param {Object} $slider - The jQuery slider element to update
 */
function updateSlickAccessibility($slider) {
    if (!$slider || !$slider.length) return;

    window.requestAnimationFrame(function() {
        try {
            // Define all potential issues including Bazaarvoice elements
            var focusableSelectors = 'a, button, input, select, textarea, .bv_main_container, .bv_reviewSummaryChevron';

            // Reset everything to -1 first
            var $allSlides = $slider.find('.slick-slide');
            $allSlides.find(focusableSelectors).attr('tabindex', '-1');
            $allSlides.attr('aria-hidden', 'true');

            // Enable Active Slides
            var $activeSlides = $slider.find('.slick-slide.slick-active');
            $activeSlides.attr('aria-hidden', 'false');

            $activeSlides.each(function() {
                var $slide = $(this);
                $slide.find(focusableSelectors).each(function() {
                    var $el = $(this);
                    
                    // VALIDATION: Only enable if it's supposed to be visible
                    // This explicitly checks if the element ITSELF has aria-hidden="true" (like tile-image-link)
                    var isExplicitlyHidden = $el.attr('aria-hidden') === 'true';
                    var hasHiddenParent = $el.closest('[aria-hidden="true"]').not($slide).length > 0;
                    var isCssHidden = $el.css('display') === 'none' || $el.css('visibility') === 'hidden';

                    if (!isExplicitlyHidden && !hasHiddenParent && !isCssHidden) {
                        $el.attr('tabindex', '0');
                    }
                });
            });
            
            // Force specific fix for tile-image-link globally just in case
            $slider.find('.tile-image-link[aria-hidden="true"]').attr('tabindex', '-1');

        } catch (e) {
            // Fail silently to prevent UI breakage
        }
    });
}

/**
 * ------------------------------------------------------------------------
 * MUTATION OBSERVER - OPTIMIZED
 * ------------------------------------------------------------------------
 * Watches for dynamic content injection and triggers fix.
 * Includes guards to prevent duplicate observers and leaks.
 * @param {Object} $carouselSelector - The jQuery element to observe
 */
function attachCarouselObserver($carouselSelector) {
    try {
        var node = $carouselSelector[0];
        if (!node) return;

        // Clean up existing observer to prevent stacking
        if (node.a11yObserver) {
            node.a11yObserver.disconnect();
            node.a11yObserver = null;
        }

        if (window.MutationObserver) {
            var timeout;
            var observer = new MutationObserver(function(mutations) {
                var shouldRun = false;
                for (var i = 0; i < mutations.length; i++) {
                    if (mutations[i].addedNodes.length > 0) {
                        shouldRun = true;
                        break;
                    }
                }
                if (shouldRun) {
                    clearTimeout(timeout);
                    timeout = setTimeout(function() {
                        updateSlickAccessibility($carouselSelector);
                    }, 500);
                }
            });
            observer.observe(node, { childList: true, subtree: true });
            
            // Store reference on the DOM node itself
            node.a11yObserver = observer;
        }
    } catch (e) {
        // MutationObserver not supported
    }
}

/**
 * Creates default slick carousle
 * @param {Element} $carouselSelector - carousel selector
 * @param {Element} $leftArrowSelector - left navigator for carousel
 * @param {Element} $rightArrowSelector - right navigator for carousel
 * @param {number} slidesToShow - number of slides to show on carousel
 * @param {number} slidesToScroll - number of slides to slide on carousel
 */
function generateDefaultSlickCarousel($carouselSelector, $leftArrowSelector, $rightArrowSelector, slidesToShow, slidesToScroll) {
    // Moving promo modal outside product tile slider
    $('#maincontent').append($carouselSelector.find('.pdp-promo-modal').detach());

    if( $leftArrowSelector.length > 0 && $rightArrowSelector.length > 0) {
        $carouselSelector.on('init reInit afterChange', function(event, slick, currentSlide){

            var cur = currentSlide || 0;
        
            // Disable prev button if on first slide
            if (cur === 0) {
                $leftArrowSelector.prop('disabled', true).addClass('disabled');
            } else {
                $leftArrowSelector.prop('disabled', false).removeClass('disabled');
            }
        
            // Disable next button if on last slide
            if (cur >= slick.slideCount - slick.options.slidesToShow) {
                $rightArrowSelector.prop('disabled', true).addClass('disabled');
            } else {
                $rightArrowSelector.prop('disabled', false).removeClass('disabled');
            }
        }).on('setPosition', function() {
            // Accessibility Fix (Delayed to ensure DOM is ready)
            var $slider = $(this);
            
            // Immediate update
            updateSlickAccessibility($slider);
            
            // Delayed update for animation end
            setTimeout(function() { 
                updateSlickAccessibility($slider); 
            }, 500);
        });
    }

    $carouselSelector.slick({
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: slidesToShow, // Default: desktop & tablet (≥768px)
        slidesToScroll: slidesToScroll
    });
    if( $leftArrowSelector.length > 0 && $rightArrowSelector.length > 0) {
        $leftArrowSelector.on('click', function () {
            $carouselSelector.slick('slickPrev');
        });
        
        $rightArrowSelector.on('click', function () {
            $carouselSelector.slick('slickNext');
        });
    }

    // Attach Observer to watch for Bazaarvoice injection
    attachCarouselObserver($carouselSelector);
}


/**
 * Creates responsive slick carousel for mobile, tablet, and desktop
 * @param {Element} $carouselSelector - carousel selector
 * @param {Element} $leftArrowSelector - left navigator for carousel
 * @param {Element} $rightArrowSelector - right navigator for carousel
 * @param {number} slidesToShow - number of slides to show on desktop
 * @param {number} slidesToScroll - number of slides to scroll on desktop
 * @param {number} slidesToShowMobile - number of slides to show on mobile
 * @param {number} slidesToScrollMobile - number of slides to scroll on mobile
 * @param {number} slidesToShowTablet - (Optional) number of slides to show on tablet
 * @param {number} slidesToScrollTablet - (Optional) number of slides to scroll on tablet
 * @param {boolean} infinite - (Optional) whether carousel loops infinitely (default: false)
 * @param {boolean} visibleArrowsMobile - (Optional) displays navigation arrows on mobile (default: true)
 * @param {Object} options - (Optional) additional options for carousel behavior
 */
function generateResponsiveSlickCarousel(
    $carouselSelector, 
    $leftArrowSelector, 
    $rightArrowSelector, 
    slidesToShow, 
    slidesToScroll, 
    slidesToShowMobile, 
    slidesToScrollMobile,
    slidesToShowTablet, 
    slidesToScrollTablet,
    infinite,
    visibleArrowsMobile,
    options
) {
    // Moving promo modal outside product tile slider
    $('#maincontent').append($carouselSelector.find('.pdp-promo-modal').detach());
    var carouselOptions = options || {};
    var isInfinite = typeof infinite === 'boolean' ? infinite : false;
    var isVisibleArrowsMobile = typeof visibleArrowsMobile === 'boolean' ? visibleArrowsMobile : true;

    if ($leftArrowSelector.length > 0 && $rightArrowSelector.length > 0) {
        $carouselSelector.on('init reInit afterChange', function (event, slick, currentSlide) {
            // Accessibility Fix (Delayed to ensure DOM is ready)
            var $slider = $(this);
            setTimeout(function () {
                updateSlickAccessibility($slider);
            }, 100);
            var cur = currentSlide || 0;
            // PLP Category Carousel - hide/show arrows
            if (carouselOptions.hideDisabledArrows) {
                // Hide arrows if there is nothing to scroll
                if (slick.slideCount <= slick.options.slidesToShow) {
                    $leftArrowSelector.hide();
                    $rightArrowSelector.hide();
                    return;
                }
                if (!isInfinite) {
                    // Start of carousel
                    if (cur === 0) {
                        $leftArrowSelector.hide();
                        $rightArrowSelector.show();
                    // End of carousel
                    } else if (cur >= slick.slideCount - slick.options.slidesToShow) {
                        $leftArrowSelector.show();
                        $rightArrowSelector.hide();
                    // Middle of carousel
                    } else {
                        $leftArrowSelector.show();
                        $rightArrowSelector.show();
                    }
                } else {
                    $leftArrowSelector.show();
                    $rightArrowSelector.show();
                }
            } else {
                // Disable prev button if on first slide unless the carousel has infinite scroll
                if (cur === 0 && !isInfinite) {
                    $leftArrowSelector.prop('disabled', true).addClass('disabled');
                } else {
                    $leftArrowSelector.prop('disabled', false).removeClass('disabled');
                }

                // Disable next button if on last slide
                if (cur >= slick.slideCount - slick.options.slidesToShow && !isInfinite) {
                    $rightArrowSelector.prop('disabled', true).addClass('disabled');
                } else {
                    $rightArrowSelector.prop('disabled', false).removeClass('disabled');
                }
            }
        }).on('setPosition', function () {
            var $slider = $(this);
            updateSlickAccessibility($slider);
            setTimeout(function () {
                updateSlickAccessibility($slider);
            }, 500);
        });
    }

    // Build responsive settings array with optional tablet breakpoint
    const responsiveSettings = [];

    // Optional tablet settings if provided
    if (slidesToShowTablet && typeof slidesToShowTablet === 'number' && slidesToScrollTablet && typeof slidesToScrollTablet === 'number') {
        responsiveSettings.push({
            breakpoint: 1200, // for devices below 1200 - covers tablet
            settings: {
                slidesToShow: slidesToShowTablet,
                slidesToScroll: slidesToScrollTablet
            }
        });
    }

    // Mobile settings (always included)
    responsiveSettings.push({
        breakpoint: 768,// for devices below 768 - covers mobile
        settings: {
            slidesToShow: slidesToShowMobile,
            slidesToScroll: slidesToScrollMobile,
            arrows: isVisibleArrowsMobile
        }
    });

    $carouselSelector.slick({
        dots: typeof carouselOptions.dots === 'boolean' ? carouselOptions.dots : true,
        infinite: isInfinite,
        speed: 300,
        slidesToShow: slidesToShow,
        slidesToScroll: slidesToScroll,
        variableWidth: carouselOptions.variableWidth === true,
        responsive: responsiveSettings 
    });

    if ($leftArrowSelector.length > 0 && $rightArrowSelector.length > 0) {
        $leftArrowSelector.on('click', function () {
            $carouselSelector.slick('slickPrev');
        });

        $rightArrowSelector.on('click', function () {
            $carouselSelector.slick('slickNext');
        });
    }

    // Attach Observer to watch for Bazaarvoice injection
    attachCarouselObserver($carouselSelector);
}


/**
 * Equalizes the height of elements based on an array of selectors.
 * @param {Array} selectors - Array of CSS selectors (e.g., ['.title', '.desc'])
 */
function matchElementHeights(selectors) {
    // 1. Reset heights to 'auto' first. 
    // This is crucial for window resizing, so elements can shrink if needed.
    $(selectors.join(', ')).css('height', 'auto');

    // 2. Loop through each selector passed in the array
    $.each(selectors, function(index, selector) {
        var maxHeight = 0;
        var $elements = $(selector);

        // 3. Find the maximum height among all elements with this selector
        $elements.each(function() {
            var currentHeight = $(this).height();
            if (currentHeight > maxHeight) {
                maxHeight = currentHeight;
            }
        });

        // 4. Apply the max height to all elements with this selector
        if (maxHeight > 0) {
            $elements.height(maxHeight);
        }
    });
}

/**
 * Styles the product labels/badges
 */
function styleProductBadges(){
    $('.product-badge').each(function(){
        const bgColor = $(this).data('bg-color');
        const textColor = $(this).data('text-color');
        $(this).css({'background-color': bgColor, 'color': textColor});
    });
}

if ($('.product-tile .product-badge').length > 0) {
    styleProductBadges();
}

/**
 * Returns a jQuery element for a toast notification with built-in close functionality
 * @param {string} options.type - 'neutral' | 'success' | 'warning' | 'error' (default: 'neutral')
 * @param {string} options.title - Toast title
 * @param {string} options.message - Toast body message
 * @param {string} [options.footer] - Optional footer text
 * @returns {jQuery} - Toast DOM element (with close behavior)
 */
function toastFunction({ type = 'neutral', title = '', message = '', footer = '', iconClass = ''}) {
    const validTypes = ['neutral', 'success', 'warning', 'error'];
    const toastType = validTypes.includes(type) ? type : 'neutral';

    var localizedTitle = title;
    if (/^success$/i.test(title)) {
        const successMsg = $('input[name="successResourceMsg"]').val();
        if (successMsg) localizedTitle = successMsg;
    } else if (/^error$/i.test(title)) {
        const errorMsg = $('input[name="errorResourceMsg"]').val();
        if (errorMsg) localizedTitle = errorMsg;
    }

    const defaultIconClass = `icon-${toastType}`;
    const appliedIconClass = iconClass || defaultIconClass;

    const html = `
        <div class="generic-toast">
            <div class="toast-wrapper toast-wrapper-${toastType}">
                <div class="toast-icon ${appliedIconClass}"></div>
                <div class="toast-content">
                    <div class="toast-header">
                        <span class="toast-title">${localizedTitle}</span>
                        <button type="button" class="toast-close" aria-label="Close">
                        </button>
                    </div>
                    <div class="toast-body">${message}</div>
                    <div class="toast-footer">${footer}</div>
                </div>
            </div>
        </div>
    `;

    const $toast = $(html);
    // Self-contained close functionality
    $toast.find('.toast-close').on('click', function () {
        $toast.fadeOut(500, function () {
            $toast.remove();
        });
    });

    return $toast;
}

/**
 * Hides duplicate shipping methods in the shipping method list, keeping only the checked or first occurrence visible.
 */
function hideDuplicateShippingMethods() {
    // Hiding duplicate shipping methods if existing
    var methodMap = new Map();
    var $formCheckContainer = $('.shipping-method-list .form-check');

    if ($formCheckContainer.length > 0) {
        $formCheckContainer.each(function (i, item) {
            var $formCheck = $(item);
            var shippingMethodName = $formCheck.find('.display-name').text().trim();
            var isChecked = $formCheck.find('.form-check-input').is(':checked');

            if (!methodMap.has(shippingMethodName)) {
                methodMap.set(shippingMethodName, {
                    elements: [$formCheck],
                    checkedElement: isChecked ? $formCheck : null
                });
            } else {
                const methodData = methodMap.get(shippingMethodName);
                methodData.elements.push($formCheck);
                if (isChecked) {
                    methodData.checkedElement = $formCheck;
                }
            }
        });

        // Process map to hide duplicates
        methodMap.forEach(({ elements, checkedElement }) => {
            elements.forEach(($element) => {
                const $pricing = $element.next('.shipping-method-pricing');
                // Keep only the checked one if available, otherwise keep the first one
                if (checkedElement) {
                    if ($element[0] !== checkedElement[0]) {
                        $element.addClass('d-none');
                        $pricing.addClass('d-none');
                    }
                } else if (!checkedElement && $element[0] !== elements[0][0]) {
                    $element.addClass('d-none');
                    $pricing.addClass('d-none');
                }
            });
        });
    }
}

/**
 *
 * @param {Object} selectElementObj - element to initialize select2 on.
 *
 */

/** To be updated later for select2
function initializeSelect2(selectElementObj) {
    selectElementObj.select2({
        width: '100%',
        minimumResultsForSearch: 0
    });

    selectElementObj.on('keydown', function (e) {
        if (e.key === 'ArrowDown') {
            e.preventDefault();
            $(this).trigger('results:next');
        }

        if (e.key === 'ArrowUp') {
            e.preventDefault();
            $(this).trigger('results:prev');  
        }

    });

    selectElementObj.on('select2:open', function () {
        let s2 = $(this).data('select2');
        s2.dropdown.$search.on('keydown.customNav', function (e) {
            let $highlighted;
            if (e.key === 'ArrowDown') {
                e.preventDefault();
                s2.trigger('results:next');
                $highlighted = s2.$results.find('.select2-results__option--highlighted');
                if ($highlighted.length) {
                    s2.dropdown.$search.val($highlighted.text().trim());
                }

            }

            if (e.key === 'ArrowUp') {
                e.preventDefault();
                s2.trigger('results:prev');
                $highlighted = s2.$results.find('.select2-results__option--highlighted');
                if ($highlighted.length) {
                    s2.dropdown.$search.val($highlighted.text().trim());
                }
            }
        });
    });
}
*/

// Initialize select2 plugin

/** To be updated later for select2
$('.sn-custom-select').each(function () {
    if (!$(this).hasClass('hide')) {
        initializeSelect2($(this));
    }
});
*/

$('.credit-card-number, .js-card-trimmed').each(function () {
    const fullTextPyamentCard = $(this).text().trim();
    const lastFourDigitsPaymentCard = fullTextPyamentCard.slice(-4);
    $(this).text('****' + lastFourDigitsPaymentCard);
});

$('body').on('click', '.logout-link', function() {
    if (window.embeddedservice_bootstrap) {
        window.embeddedservice_bootstrap.userVerificationAPI.clearSession();
    }
});

/**
 * Adds an astersks
 */
$('label.custom-control-label').each(function () {
    var $label = $(this);
    var inputId = $label.attr('for');
    var $input = $('#' + inputId);

    if ($input.length 
        && $input.prop('required') 
        && $.inArray($input.attr('type'), ['submit', 'image', 'range']) === -1
    ) {
        // Only append once
        if ($label.find('.required-asterisk').length === 0) {
            $('<span>')
                .addClass('required-asterisk')
                .text('*')
                .appendTo($label);
        }
    }
});

$('body').on('click keydown', '.product-container .product-details', function(e) {
    const productUrl = $(this).data('product-url');
    if (productUrl && (e.type === 'click' || (e.type === 'keydown' && (e.key === 'Enter' || e.key === ' ')))) {
        window.location.href = productUrl;
    }
});

/**
 * 
 * @param {string} url - url to check
 * @param {string} csrfToken - CSRF token to append to the URL
 * @returns {string} - URL with appended CSRF token
 */
function appendCsrfTokenToUrl(url, csrfToken) {
    if (!csrfToken) {
        return url;
    }
    var separator = url.includes('?') ? '&' : '?';
    return url + separator + 'csrf_token=' + encodeURIComponent(csrfToken);
}

/**
 * Resolves the add-to-cart URL with a CSRF token. Uses the token already on the page when there is one.
 * Otherwise fetches a fresh token from Cart-CsrfToken, because tile and quick-view markup is cached and
 * must not carry a session token.
 *
 * @param {string} addToCartUrl - Cart-AddProduct URL
 * @param {string} [pageToken] - token rendered on the page next to the add-to-cart URL, if any
 * @returns {Object} - jQuery promise resolving to the add-to-cart URL with the token appended
 */
function getAddToCartUrlWithToken(addToCartUrl, pageToken) {
    if (pageToken) {
        return $.Deferred().resolve(appendCsrfTokenToUrl(addToCartUrl, pageToken)).promise();
    }
    return $.ajax({
        url: addToCartUrl.replace('Cart-AddProduct', 'Cart-CsrfToken'),
        method: 'GET',
        dataType: 'json'
    }).then(function (data) {
        var token = data && data.csrf ? data.csrf.token : null;
        return appendCsrfTokenToUrl(addToCartUrl, token);
    });
}

module.exports = { generateDefaultSlickCarousel, generateResponsiveSlickCarousel, styleProductBadges, matchElementHeights, toastFunction, hideDuplicateShippingMethods, updateSlickAccessibility, attachCarouselObserver, SUBSCRIPTION_RESUME_URL_KEY, appendCsrfTokenToUrl, getAddToCartUrlWithToken };
